module.exports = __webpack_public_path__ + "static/media/iconuser.42b9ada5.png";